import {rendersLoginScreenFirst} from 'web-app/setup/renders-login-screen-first';

/**
 * Decided once, from the URL the app was opened on: the boot either waits for the login screen's
 * namespace or for the global catalogue, and nothing later can change which one it waited for.
 */
export const bootsIntoLoginScreen = rendersLoginScreenFirst();
